import Icon from './Icon';
import styles from './SegmentedControl.module.css';

export type OpcaoSegmento = {
  id: string;
  rotulo: string;
  icone?: string;
};

export type SegmentedControlProps = {
  opcoes: OpcaoSegmento[];
  valor: string;
  onChange: (id: string) => void;
};

export default function SegmentedControl({ opcoes, valor, onChange }: SegmentedControlProps) {
  return (
    <div className={styles.controle} role="tablist">
      {opcoes.map((opcao) => (
        <button
          key={opcao.id}
          type="button"
          role="tab"
          aria-selected={opcao.id === valor}
          className={`${styles.opcao} ${opcao.id === valor ? styles.ativa : ''}`}
          onClick={() => onChange(opcao.id)}
        >
          {opcao.icone && <Icon nome={opcao.icone} tamanho={16} />}
          {opcao.rotulo}
        </button>
      ))}
    </div>
  );
}
